module.exports = __webpack_public_path__ + "img/祝礼祥.fa457f73.jpg";